/**
 * Sentry init. No-op when VITE_SENTRY_DSN is unset (local dev / CI),
 * so nothing leaks during development. Production .env.local should
 * carry a real DSN.
 *
 * Privacy stance: errors only. No session replay, no breadcrumb
 * collection of user input. We're a language tutor — chat content is
 * sensitive.
 */
import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;
const env = import.meta.env.VITE_SENTRY_ENV ?? import.meta.env.MODE;

if (dsn) {
  Sentry.init({
    dsn,
    environment: env,
    // Capture exceptions + unhandled promise rejections only.
    // No tracing / profiling / replays.
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    sendDefaultPii: false,
    // Strip URL query strings — they sometimes carry tokens.
    beforeSend(event) {
      if (event.request?.url) {
        try {
          const u = new URL(event.request.url);
          u.search = "";
          event.request.url = u.toString();
        } catch { /* noop */ }
      }
      return event;
    },
  });
}

export { Sentry };
